import { IntroWrapper } from './__intro-elements';
import { getPath, Path } from 'components/_hooks/use-router';
import { useMemo } from 'react';

const useTourDetails = () => {
  const path = getPath();
  return useMemo(() => {
    switch (path) {
      case Path.projects:
        return { key: 'Projects', title: 'Projects Tour' };
      case Path.selector:
        return { key: 'Highlights', title: 'Highlights Tour' };
      case Path.storyboard:
        return { key: 'Storyboard', title: 'Storyboard Tour' };
      default:
        return { key: '', title: '' };
    }
  }, []);
};

export const HelpMode = () => {
  return (
    <IntroWrapper size="medium">
      <h3>Help Mode</h3>
      <p>
        <b>Help Mode</b> adds interactive <b>tooltips</b> and <b>tutorials</b> throughout the app to guide you.
      </p>
      <p>Hover over items on the page to see helpful tips in action — try it now.</p>
      <p>
        Turn <b>Help Mode</b> off to hide all tooltips, tutorials, and tours. You can toggle it on or off anytime with
        this button.
      </p>
    </IntroWrapper>
  );
};

export const HelpModeReminder = () => {
  const { key } = useTourDetails();
  return (
    <IntroWrapper size="medium">
      <h3>Help Mode</h3>
      <p>
        Need {key} help? Toggle <b>Help Mode</b> anytime to see tooltips and tutorials.
      </p>
    </IntroWrapper>
  );
};

export const Tutorials = () => (
  <IntroWrapper size="medium">
    <h3>Tutorials</h3>
    <p>
      Want quick tips while you work? Click the <b>?</b> button anytime to turn on{' '}
      <b>short, helpful tutorials and videos</b> for key parts of the editor.
    </p>
    <p>
      With tutorials on, click highlighted items to see <b>step-by-step guides</b> and extra tips.
    </p>
    <p>
      Turn them off to hide all tutorials. <b>Click ? to toggle them on or off</b> anytime.
    </p>
  </IntroWrapper>
);

export const TutorialsReminder = () => {
  const { key } = useTourDetails();
  return (
    <IntroWrapper size="medium">
      <h3>Tutorials</h3>
      <p>
        Need {key} tips? Toggle <b>Tutorials</b> anytime with the <b>?</b> button.
      </p>
    </IntroWrapper>
  );
};

export const StartTour = () => {
  const { key, title } = useTourDetails(); // Same hook, same values
  return (
    <IntroWrapper size="medium">
      <h3>{title}</h3>
      <p>
        The {key} page includes a guided <b>Tour</b> that walks you through the general workflow.
      </p>
      <p>
        Prefer to explore {key} on your own? <b>You can skip the {title}</b> and start it anytime later by clicking{' '}
        <b>Start Tour</b>.
      </p>
    </IntroWrapper>
  );
};
